<app-page-header title="Home" active_item="Saque Copia e Cola"></app-page-header>
<div class="loading-transferencia" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>Transferência via BR-Code</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Dados do Pagamento</div>
      </div>
      <div class="card-body">
        <div class="alert alert-dark text-center" role="alert">
          <b
            >Saldo Disponível: R$
            {{
              saldoDisponivel
                | mask : "separator.2" : { decimalMarker: ",", thousandSeparator: ".", leadZero: true }
            }}</b
          >
        </div>
        <form [formGroup]="saque">
          <div class="row">
            <div class="col-xl-12 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtChavePix" class="form-label"
                  >Copia e Cola <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  [formControl]="saque.controls.chavePix"
                  name="chavePix"
                  id="txtChavePix"
                  *ngIf="saque.controls.tipoChave.value === ''"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.chavePix.invalid && isSubmitted
                  }"
                  [readonly]="false"
                />
                <input
                  class="form-control"
                  type="text"
                  [formControl]="saque.controls.chavePix"
                  name="chavePix"
                  *ngIf="saque.controls.tipoChave.value === 'EVP'"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.chavePix.invalid && isSubmitted
                  }"
                  [readonly]="openConfirm"
                />
                <div class="invalid-feedback">{{ chavePixFeedBack }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-5 col-lg-6 col-sm-6">
                <div class="form-group">
                  <label for="txtDocumentoRecebedor" class="form-label">
                    Documento Recebedor <span class="text-danger">*</span>
                  </label>
                  <input
                    mask="CPF_CNPJ"
                    [formControl]="saque.controls.documentoRecebedor"
                    class="form-control"
                    type="text"
                    name="documentoRecebedor"
                    id="txtDocumentoRecebedor"
                    [ngClass]="{
                      'is-invalid state-invalid':
                        saque.controls.documentoRecebedor.invalid && isSubmitted
                    }"
                  />
                  <div class="invalid-feedback">{{ documentoFeedBack }}</div>
                </div>
              </div>              
            </div>
          </div>
          <div class="row">
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label"
                  >Valor do QR Code <span class="text-danger">*</span></label
                >
                <input
                  [placeholder]="placeholderValue"
                  [formControl]="saque.controls.valorSolicitado"
                  currencyMask
                  [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                  class="form-control"
                  type="text"
                  name="valorSolicitado"
                  id="txtValorSolicitado"
                  (focusout)="valorSolicitadoChanged()"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.valorSolicitado.invalid && isSubmitted
                  }"
                />
                <label for="txtValorSolicitado" class="txtAviso"
                  >Valor deve ser igual ao QR Code</label
                >
                <div class="invalid-feedback">{{ valorFeedBack }}</div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtTaxa" class="form-label">Taxa</label>
                <input
                  prefix="R$ "
                  [formControl]="saque.controls.taxa"
                  mask="separator.2"
                  [leadZero]="true"
                  decimalMarker=","
                  thousandSeparator="."
                  class="form-control"
                  type="text"
                  name="taxa"
                  id="txtTaxa"
                  [readonly]="true"
                />
              </div>
            </div>
            <div class="col-xl-5 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorTotal" class="form-label"
                  >Valor total</label
                >
                <input
                  prefix="R$ "
                  [formControl]="saque.controls.valorTotal"
                  mask="separator.2"
                  [leadZero]="true"
                  decimalMarker=","
                  thousandSeparator="."
                  class="form-control"
                  type="text"
                  name="valorTotal"
                  id="txtValorTotal"
                  [readonly]="true"
                />
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="makeWithdraw()"
              >
                <i class="fe fe-arrow-up-right"></i>Transferir
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
